import React from 'react';
import PropTypes from 'prop-types';
import {cloneDeep} from "lodash";
import {Formik} from "formik";
import * as Yup from 'yup';
import {Button, Col, Divider, Form, Radio, Typography} from "antd";
import {CodeMultiFastInput, CodeSingleFastInput, CodeTreeFastInput, TextInput} from "../Boilerplate/formikComponents";
import * as R from "ramda";

const PrivacySettingInput = ({ values, errors, handleSubmit, setFieldValue, setFieldTouched, name, placeholder, formItemLayout, label, inputProps }) => {
  if (values[name] !== undefined) inputProps['value'] = values[name];
  return (
    <Form.Item
      // prefixCls={} label={} labelCol={}  wrapperCol={} className={} id={} colon={}
      validateStatus={errors[name] && 'error'}
      hasFeedback={!!errors[name]}
      help={errors[name]}
      label={label}
      {...formItemLayout}
    >
      <Radio.Group
        onChange={event => setFieldValue(name, event.target.value)}
        onBlur={() => setFieldTouched(name)}
        {...inputProps}
      >
        <Col xs={24} sm={8}>
          <Radio value={0}>{values.companyname || 'My Company'}</Radio>
          <Typography><Typography.Paragraph style={{ lineHeight: 1.5, fontSize: 13 }}>
            <Typography.Text type={'secondary'}>Only users within your company can
              visit your company info page.</Typography.Text></Typography.Paragraph></Typography>
        </Col>
        <Col xs={24} sm={8}>
          <Radio value={1}>cProject</Radio>
          <Typography><Typography.Paragraph style={{ lineHeight: 1.5, fontSize: 13 }}>
            <Typography.Text type={'secondary'}>Anyone with an account in cProject can
              visit your company info page.</Typography.Text></Typography.Paragraph></Typography>
        </Col>
        <Col xs={24} sm={8}>
          <Radio value={2}>Public</Radio>
          <Typography><Typography.Paragraph style={{ lineHeight: 1.5, fontSize: 13 }}>
            <Typography.Text type={'secondary'}>Your company info page will be published to
              the web and publicly accessible.</Typography.Text></Typography.Paragraph></Typography>
        </Col>
      </Radio.Group>
    </Form.Item>
  );
};

const blank_pqf = {
  "Legal": {
    "Legal Information": {
      "Has your organization or company officers ever filed for bankruptcy?": "",
      "If you answered YES to any of the above questions, please explain in detail": "",
      "Has your organization ever failed to complete any work awarded to it or had a contract terminated for cause?": "",
      "Has your organization or any of its officers ever been debarred by any Federal, State, or Local Government Agency?": "",
      "Are there any judgements, claims, arbitration proceedings, or lawsuits pending or outstanding against your organization?": "",
      "Has your organization filed any lawsuits or requested arbitration regarding any construction contracts within the last 5 years?": ""
    },
    "Terms and Conditions": { "I understand that the information recorded and stored on the cProject standardized pre-qualification form is viewable by all cProject users that are classified as General Contractors. General Contractors may use this data to when deciding which contractors are invited to bid their projects. ": "" },
    "Who Completed this Pre-Qualification Form?": {
      "Full Name, Title, and Email": "",
      "I certify that all information provided on this Form is true and complete": ""
    }
  },
  "Safety": {
    "Safety Record": {
      "# of Fatalities": "",
      "Total # Man-Hours": "",
      "# of Lost Work Days": "",
      "# of OSHA Citations": "",
      "# of OSHA Recordable Incidents": "",
      "Current Experience Modification Rate (EMR)": "",
      "OSHA Total Recordable Incident Rate (TRIR)": "",
      "Does your company have a dedicated Safety Manager?": "",
      "Does your company conduct drug and alcohol testing?": "",
      "(WB) Does your company have a written Safety Manual?": ""
    },
    "Safety Contact": { "Email": "", "Phone": "", "Title": "", "Last Name": "", "First Name": "" },
    "Supporting Documents": {}
  },
  "General": {
    "Company Address": { "Zip": "", "City": "", "State": " ", "Address 1": "", "Address 2": "" },
    "Company Information": {
      "Company Fax": "",
      "Company Phone": "",
      "Company Website": "",
      "Legal Company Name": "",
      "Federal Tax ID Number": "",
      "Dunn and Bradstreet Number": "",
      "Supporting Documents Uploaded?": ""
    }
  },
  "Quality": {
    "QA/QC Contact": { "Email": "", "Phone": "", "Title": "", "Last Name": "", "First Name": "" },
    "Quality Information": {
      "If Yes, list certifications:": "",
      "Does your company have a dedicated QA/QC Manager?": "",
      "Does your company have any Quality Certifications": ""
    },
    "Supporting Documents": {}
  },
  "Services": {
    "Products and/or Services": {
      "Select CSI Code(s)": "",
      "% of Work Self-Performed": "",
      "List NAICS Codes (separate multiple codes by comma)": "",
      "What type of work do you typically subcontract (if any)": "",
      "List Specific Keywords that describe your company's specialty": ""
    }
  },
  "Insurance": {
    "Insurance Contact": { "Email": "", "Phone": "", "Company": "", "Full Name": "" },
    "Insurance Coverage": {
      "Auto Liability - Amount": "",
      "Auto Liability - Expiration": "",
      "Workers Compensation - Amount": "",
      "Workers Compensation - Expiration": "",
      "Excess/Umbrella Liability - Amount": "",
      "Commercial General Liability - Amount": "",
      "Excess/Umbrella Liability - Expiration": "",
      "Employment Practices Liability - Amount": "",
      "Errors and Omissions Liability - Amount": "",
      "Commercial General Liability - Expiration": "",
      "Employment Practices Liability - Expiration": "",
      "Errors and Omissions Liability - Expiration": ""
    },
    "Supporting Documents": {}
  },
  "Green/LEED": {
    "Greeen/LEED Information": {
      "How many LEED Certified Employees at your Company?": "",
      "Has your company done work on a LEED Certified Project?": "",
      "If Yes, list references (Include Company, Contact Name, Phone, and Email)": ""
    }
  },
  "Organization": {
    "Financial": {
      "Current Backlog": "",
      "Revenue - Last Year": "",
      "Revenue - 2 Years Ago": "",
      "Revenue - 3 Years Ago": "",
      "Company Net Worth (Shareholder's Equity)": ""
    },
    "About your Company": {
      "Business Type": " ",
      "Years in Business": "",
      "Union Affiliation?": "",
      "# Employees - Field": "",
      "# Employees - Office": "",
      "Date of Incorporation": "",
      "State of Incorporation": "",
      "Under Present Ownership Since:": "",
      "If Union, List Union Affiliations": ""
    }
  },
  "Work Locations": { "Geographic Areas": { "Areas Worked": "" } },
  "Bonding/Banking": {
    "Banking Contact": { "Email": "", "Phone": "", "Company": "", "Full Name": "" },
    "Bonding Contact": { "Email": "", "Phone": "", "Full Name": "", "Surety Name": "" },
    "Bonding Capacity": { "Aggregate": "", "Single Project": "" }
  },
  "Company Contact(s)": {
    "Primary Contact": {
      "Cell": "",
      "Email": "",
      "Phone": "",
      "Title": "",
      "Last Name": "",
      "First Name": ""
    },
    "Secondary Contact": {
      "2nd: Cell": "",
      "2nd: Email": "",
      "2nd: Phone": "",
      "2nd: Title": "",
      "2nd: Last Name": "",
      "2nd: First Name": ""
    }
  },
  "Supporting Documents": {
    "Safety": {},
    "General": {},
    "Quality": {},
    "Insurance": {},
    "Classifications/Licenses": {}
  },
  "Experience/References": {
    "Credit/Supplier References": {
      "Credit Reference #1 (Include Company Name, Location, Contact Name, Phone, and Email)": "",
      "Credit Reference #2 (Include Company Name, Location, Contact Name, Phone, and Email)": "",
      "Credit Reference #3 (Include Company Name, Location, Contact Name, Phone, and Email)": ""
    },
    "Current/Recent Project Reference #1": {
      "Ref #1 - Project Name": "",
      "Ref #1 - Contract Value": "",
      "Ref #1 - Owner/End User": "",
      "Ref #1 - General Contractor": "",
      "Ref #1 - Project Description": "",
      "Ref #1 - Location (Include City, State, and Country)": "",
      "Ref #1 - Completion Date (or Estimated Completion Date)": "",
      "Ref #1 - Reference Contact (Include Name, Title, Company, Phone, Email)": ""
    },
    "Current/Recent Project Reference #2": {
      "Ref #2 - Project Name": "",
      "Ref #2 - Contract Value": "",
      "Ref #2 - Owner/End User": "",
      "Ref #2 - General Contractor": "",
      "Ref #2 - Project Description": "",
      "Ref #2 - Location (Include City, State, and Country)": "",
      "Ref #2 - Completion Date (or Estimated Completion Date)": "",
      "Ref #2 - Reference Contact (Include name, title, company, phone, and email)": ""
    },
    "Current/Recent Project Reference #3": {
      "Ref #3 - Project Name": "",
      "Ref #3 - Contract Value": "",
      "Ref #3 - Owner/End User": "",
      "Ref #3 - General Contractor": "",
      "Ref #3 - Project Description": "",
      "Ref #3 - Location (Include City, State, and Country)": "",
      "Ref #3 - Completion Date (or Estimated Completion Date)": "",
      "Ref #3 - Reference Contact (Include name, title, company, phone, and email)": ""
    }
  },
  "Classifications/Licenses": {
    "Contractor Licenses": { "List Licenses (include state, type, license #, and expiration date)": "" },
    "Supporting Documents": {},
    "Classification Information": {
      "If yes, what is your CAGE Code": "",
      "If Minority Owned, select option": "",
      "Is your company listed in the Central Contractor Registration (CCR)": ""
    }
  }
};

const validationSchema = Yup.object().shape({
  id: Yup.string().nullable(),
  companyname: Yup.string().nullable(),
  address: Yup.string().nullable(),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  zip: Yup.string().nullable(),
  companytype: Yup.string().nullable(),
  website: Yup.string().nullable(),
  email: Yup.string().nullable(),
  phone: Yup.string().nullable(),
  fax: Yup.string().nullable(),
  // industries
  // sectors
  // csicodes
  // subcompanytype
  // abbreviation
  // logo
});

const CompanyForm = props => {
  const { company, onCancel, onSubmit, duringRegistration = false } = props;
  let initials;
  if (company) {
    initials = cloneDeep(company);

    if (initials.pqf) {
      initials['pqf-services-selfperformed'] = initials.pqf["Services"]["Products and/or Services"]["% of Work Self-Performed"];
      initials['pqf-worklocations-areasworked'] = initials.pqf["Work Locations"]["Geographic Areas"]["Areas Worked"];
      initials['pqf-experiencereferences-1-name'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Project Name"];
      initials['pqf-experiencereferences-1-owner'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Owner/End User"];
      initials['pqf-experiencereferences-1-gc'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - General Contractor"];
      initials['pqf-experiencereferences-1-reference'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Reference Contact (Include Name, Title, Company, Phone, Email)"];
      initials['pqf-experiencereferences-1-location'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Location (Include City, State, and Country)"];
      initials['pqf-experiencereferences-1-value'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Contract Value"];
      initials['pqf-experiencereferences-1-date'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Completion Date (or Estimated Completion Date)"];
      initials['pqf-experiencereferences-1-description'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Project Description"];
      initials['pqf-experiencereferences-2-name'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Project Name"];
      initials['pqf-experiencereferences-2-owner'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Owner/End User"];
      initials['pqf-experiencereferences-2-gc'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - General Contractor"];
      initials['pqf-experiencereferences-2-reference'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Reference Contact (Include name, title, company, phone, and email)"];
      initials['pqf-experiencereferences-2-location'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Location (Include City, State, and Country)"];
      initials['pqf-experiencereferences-2-value'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Contract Value"];
      initials['pqf-experiencereferences-2-date'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Completion Date (or Estimated Completion Date)"];
      initials['pqf-experiencereferences-2-description'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Project Description"];
      initials['pqf-experiencereferences-3-name'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Project Name"];
      initials['pqf-experiencereferences-3-owner'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Owner/End User"];
      initials['pqf-experiencereferences-3-gc'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - General Contractor"];
      initials['pqf-experiencereferences-3-reference'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Reference Contact (Include name, title, company, phone, and email)"];
      initials['pqf-experiencereferences-3-location'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Location (Include City, State, and Country)"];
      initials['pqf-experiencereferences-3-value'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Contract Value"];
      initials['pqf-experiencereferences-3-date'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Completion Date (or Estimated Completion Date)"];
      initials['pqf-experiencereferences-3-description'] = initials.pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Project Description"];
      initials['pqf-experiencereferences-credit-1'] = initials.pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #1 (Include Company Name, Location, Contact Name, Phone, and Email)"];
      initials['pqf-experiencereferences-credit-2'] = initials.pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #2 (Include Company Name, Location, Contact Name, Phone, and Email)"];
      initials['pqf-experiencereferences-credit-3'] = initials.pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #3 (Include Company Name, Location, Contact Name, Phone, and Email)"];
      initials['pqf-contacts-primary-first'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["First Name"];
      initials['pqf-contacts-primary-last'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["Last Name"];
      initials['pqf-contacts-primary-title'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["Title"];
      initials['pqf-contacts-primary-email'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["Email"];
      initials['pqf-contacts-primary-phone'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["Phone"];
      initials['pqf-contacts-primary-cell'] = initials.pqf["Company Contact(s)"]["Primary Contact"]["Cell"];
      initials['pqf-contacts-secondary-first'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: First Name"];
      initials['pqf-contacts-secondary-last'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Last Name"];
      initials['pqf-contacts-secondary-title'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Title"];
      initials['pqf-contacts-secondary-email'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Email"];
      initials['pqf-contacts-secondary-phone'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Phone"];
      initials['pqf-contacts-secondary-cell'] = initials.pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Cell"];
    } else {
      initials['pqf-general-taxnumber'] = '';
      initials['pqf-general-documents'] = '';
      initials['pqf-services-selfperformed'] = '';
      initials['pqf-worklocations-areasworked'] = '';
      initials['pqf-experiencereferences-1-name'] = '';
      initials['pqf-experiencereferences-1-owner'] = '';
      initials['pqf-experiencereferences-1-gc'] = '';
      initials['pqf-experiencereferences-1-reference'] = '';
      initials['pqf-experiencereferences-1-location'] = '';
      initials['pqf-experiencereferences-1-value'] = '';
      initials['pqf-experiencereferences-1-date'] = '';
      initials['pqf-experiencereferences-1-description'] = '';
      initials['pqf-experiencereferences-2-name'] = '';
      initials['pqf-experiencereferences-2-owner'] = '';
      initials['pqf-experiencereferences-2-gc'] = '';
      initials['pqf-experiencereferences-2-reference'] = '';
      initials['pqf-experiencereferences-2-location'] = '';
      initials['pqf-experiencereferences-2-value'] = '';
      initials['pqf-experiencereferences-2-date'] = '';
      initials['pqf-experiencereferences-2-description'] = '';
      initials['pqf-experiencereferences-3-name'] = '';
      initials['pqf-experiencereferences-3-owner'] = '';
      initials['pqf-experiencereferences-3-gc'] = '';
      initials['pqf-experiencereferences-3-reference'] = '';
      initials['pqf-experiencereferences-3-location'] = '';
      initials['pqf-experiencereferences-3-value'] = '';
      initials['pqf-experiencereferences-3-date'] = '';
      initials['pqf-experiencereferences-3-description'] = '';
      initials['pqf-experiencereferences-credit-1'] = '';
      initials['pqf-experiencereferences-credit-2'] = '';
      initials['pqf-experiencereferences-credit-3'] = '';
      initials['pqf-contacts-primary-first'] = '';
      initials['pqf-contacts-primary-last'] = '';
      initials['pqf-contacts-primary-title'] = '';
      initials['pqf-contacts-primary-email'] = '';
      initials['pqf-contacts-primary-phone'] = '';
      initials['pqf-contacts-primary-cell'] = '';
      initials['pqf-contacts-secondary-first'] = '';
      initials['pqf-contacts-secondary-last'] = '';
      initials['pqf-contacts-secondary-title'] = '';
      initials['pqf-contacts-secondary-email'] = '';
      initials['pqf-contacts-secondary-phone'] = '';
      initials['pqf-contacts-secondary-cell'] = '';
    }
  } else {
    initials = {
    }
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };
  return (
    <Formik
      initialValues={initials}
      onSubmit={(values, { setSubmitting }) => {
        values = cloneDeep(values);
        const pqf = values['pqf'] || blank_pqf;

        pqf["Services"]["Products and/or Services"]["% of Work Self-Performed"] = values['pqf-services-selfperformed'];
        pqf["Work Locations"]["Geographic Areas"]["Areas Worked"] = values['pqf-worklocations-areasworked'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Project Name"] = values['pqf-experiencereferences-1-name'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Owner/End User"] = values['pqf-experiencereferences-1-owner'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - General Contractor"] = values['pqf-experiencereferences-1-gc'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Reference Contact (Include Name, Title, Company, Phone, Email)"] = values['pqf-experiencereferences-1-reference'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Location (Include City, State, and Country)"] = values['pqf-experiencereferences-1-location'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Contract Value"] = values['pqf-experiencereferences-1-value'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Completion Date (or Estimated Completion Date)"] = values['pqf-experiencereferences-1-date'];
        pqf["Experience/References"]["Current/Recent Project Reference #1"]["Ref #1 - Project Description"] = values['pqf-experiencereferences-1-description'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Project Name"] = values['pqf-experiencereferences-2-name'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Owner/End User"] = values['pqf-experiencereferences-2-owner'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - General Contractor"] = values['pqf-experiencereferences-2-gc'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Reference Contact (Include name, title, company, phone, and email)"] = values['pqf-experiencereferences-2-reference'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Location (Include City, State, and Country)"] = values['pqf-experiencereferences-2-location'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Contract Value"] = values['pqf-experiencereferences-2-value'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Completion Date (or Estimated Completion Date)"] = values['pqf-experiencereferences-2-date'];
        pqf["Experience/References"]["Current/Recent Project Reference #2"]["Ref #2 - Project Description"] = values['pqf-experiencereferences-2-description'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Project Name"] = values['pqf-experiencereferences-3-name'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Owner/End User"] = values['pqf-experiencereferences-3-owner'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - General Contractor"] = values['pqf-experiencereferences-3-gc'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Reference Contact (Include name, title, company, phone, and email)"] = values['pqf-experiencereferences-3-reference'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Location (Include City, State, and Country)"] = values['pqf-experiencereferences-3-location'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Contract Value"] = values['pqf-experiencereferences-3-value'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Completion Date (or Estimated Completion Date)"] = values['pqf-experiencereferences-3-date'];
        pqf["Experience/References"]["Current/Recent Project Reference #3"]["Ref #3 - Project Description"] = values['pqf-experiencereferences-3-description'];
        pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #1 (Include Company Name, Location, Contact Name, Phone, and Email)"] = values['pqf-experiencereferences-credit-1'];
        pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #2 (Include Company Name, Location, Contact Name, Phone, and Email)"] = values['pqf-experiencereferences-credit-2'];
        pqf["Experience/References"]["Credit/Supplier References"]["Credit Reference #3 (Include Company Name, Location, Contact Name, Phone, and Email)"] = values['pqf-experiencereferences-credit-3'];
        pqf["Company Contact(s)"]["Primary Contact"]["First Name"] = values['pqf-contacts-primary-first'];
        pqf["Company Contact(s)"]["Primary Contact"]["Last Name"] = values['pqf-contacts-primary-last'];
        pqf["Company Contact(s)"]["Primary Contact"]["Title"] = values['pqf-contacts-primary-title'];
        pqf["Company Contact(s)"]["Primary Contact"]["Email"] = values['pqf-contacts-primary-email'];
        pqf["Company Contact(s)"]["Primary Contact"]["Phone"] = values['pqf-contacts-primary-phone'];
        pqf["Company Contact(s)"]["Primary Contact"]["Cell"] = values['pqf-contacts-primary-cell'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: First Name"] = values['pqf-contacts-secondary-first'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Last Name"] = values['pqf-contacts-secondary-last'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Title"] = values['pqf-contacts-secondary-title'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Email"] = values['pqf-contacts-secondary-email'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Phone"] = values['pqf-contacts-secondary-phone'];
        pqf["Company Contact(s)"]["Secondary Contact"]["2nd: Cell"] = values['pqf-contacts-secondary-cell'];

        values = R.pickBy((v, k) => !k.startsWith('pqf-'), values);
        values['pqf'] = pqf;

        onSubmit && onSubmit(values);
      }}
      validationSchema={validationSchema}
    >
      {props => {
        const {
          values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <Form>
            <Divider><h1>Profile Visibility Settings</h1></Divider>
            <PrivacySettingInput {...props} formItemLayout={formItemLayout} label='Visibility Level' name='profileprivacy' inputProps={{defaultValue: 1}}
            // inputProps={{
            //   min: 0, max: 2, defaultValue: 0, included: false,
            //   marks: {
            //     0: values.companyname || 'My Company',
            //     1: 'cProject',
            //     2: 'Public',
            //   },
            //   tipFormatter: v => v === 0 ? 'Only users within your company can visit your company info page' :
            //     v === 1 ? 'Anyone with an account in cProject can visit your company info page' :
            //       'Your company info page will be published to the web and publicly accessible',
            // }}
            />
            <Divider><h1>General</h1></Divider>
            <TextInput {...props} formItemLayout={formItemLayout} label='Company Name' name='companyname' placeholder='Enter a company name'/>
            <CodeSingleFastInput {...props} formItemLayout={formItemLayout} label='Company Type' name='companytype' table='companytype' placeholder='Select a company type'/>
            <Divider>Address</Divider>
            <TextInput {...props} formItemLayout={formItemLayout} label='Address Line 1' name='address' placeholder='Street address'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Address Line 2' name='address2' placeholder='Suite #'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='City' name='city' placeholder='City'/>
            <CodeSingleFastInput {...props} formItemLayout={formItemLayout} label='State' name='state' table='states' placeholder='Type a state name...' defaultValue='TX'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Zip' name='zip' placeholder='Zip Code'/>
            <Divider>Contact</Divider>
            <TextInput {...props} formItemLayout={formItemLayout} label='Phone' name='phone' placeholder='Phone number'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Fax' name='fax' placeholder='Fax'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Email' name='email' placeholder='Email'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Website' name='website' placeholder='Website'/>
            <Divider/>

            {!duringRegistration && <React.Fragment>
              <Divider><h1>Services</h1></Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Percentage of Work Self-Performed' name='pqf-services-selfperformed' placeholder=' '/>
              <CodeTreeFastInput {...props} formItemLayout={formItemLayout} label='CSI Codes' name='csicodes' table='csi_hierarchy'/>
              <CodeMultiFastInput {...props} formItemLayout={formItemLayout} label='Industries' name='industries' table='industry'/>
              <CodeMultiFastInput {...props} formItemLayout={formItemLayout} label='Sectors' name='sectors' table='sector'/>

              <Divider><h1>Work Locations</h1></Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Areas Worked' name='pqf-worklocations-areasworked' placeholder='citywide, statewide, regionally, nationally, internationally'/>

              <Divider><h1>Experiences / References</h1></Divider>
              <Divider>Current / Reference Project Reference #1</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Name' name='pqf-experiencereferences-1-name' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Owner / End User' name='pqf-experiencereferences-1-owner' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='General Contractor' name='pqf-experiencereferences-1-gc' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Reference Contact' name='pqf-experiencereferences-1-reference' placeholder='Include Name, Title, Company, Phone, Email'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Location' name='pqf-experiencereferences-1-location' placeholder='Include City, State, and Country'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Contract Value' name='pqf-experiencereferences-1-value' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Completion Date' name='pqf-experiencereferences-1-date' placeholder='Completion Date or Estimated Completion Date'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Description' name='pqf-experiencereferences-1-description' placeholder=' '/>
              <Divider>Current / Reference Project Reference #2</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Name' name='pqf-experiencereferences-2-name' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Owner / End User' name='pqf-experiencereferences-2-owner' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='General Contractor' name='pqf-experiencereferences-2-gc' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Reference Contact' name='pqf-experiencereferences-2-reference' placeholder='Include Name, Title, Company, Phone, Email'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Location' name='pqf-experiencereferences-2-location' placeholder='Include City, State, and Country'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Contract Value' name='pqf-experiencereferences-2-value' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Completion Date' name='pqf-experiencereferences-2-date' placeholder='Completion Date or Estimated Completion Date'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Description' name='pqf-experiencereferences-2-description' placeholder=' '/>
              <Divider>Current / Reference Project Reference #3</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Name' name='pqf-experiencereferences-3-name' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Owner / End User' name='pqf-experiencereferences-3-owner' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='General Contractor' name='pqf-experiencereferences-3-gc' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Reference Contact' name='pqf-experiencereferences-3-reference' placeholder='Include Name, Title, Company, Phone, Email'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Location' name='pqf-experiencereferences-3-location' placeholder='Include City, State, and Country'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Contract Value' name='pqf-experiencereferences-3-value' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Completion Date' name='pqf-experiencereferences-3-date' placeholder='Completion Date or Estimated Completion Date'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Project Description' name='pqf-experiencereferences-3-description' placeholder=' '/>
              <Divider>Credit / Supplier References</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='Credit Reference #1' name='pqf-experiencereferences-credit-1' placeholder='Include Company Name, Location, Contact Name, Phone, and Email'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Credit Reference #2' name='pqf-experiencereferences-credit-2' placeholder='Include Company Name, Location, Contact Name, Phone, and Email'/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Credit Reference #3' name='pqf-experiencereferences-credit-3' placeholder='Include Company Name, Location, Contact Name, Phone, and Email'/>

              <Divider><h1>Company Contacts</h1></Divider>
              <Divider>Primary Contact</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='First Name' name='pqf-contacts-primary-first' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Last Name' name='pqf-contacts-primary-last' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Title' name='pqf-contacts-primary-title' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Email' name='pqf-contacts-primary-email' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Phone' name='pqf-contacts-primary-phone' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Cell' name='pqf-contacts-primary-cell' placeholder=' '/>
              <Divider>Secondary Contact</Divider>
              <TextInput {...props} formItemLayout={formItemLayout} label='First Name' name='pqf-contacts-secondary-first' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Last Name' name='pqf-contacts-secondary-last' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Title' name='pqf-contacts-secondary-title' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Email' name='pqf-contacts-secondary-email' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Phone' name='pqf-contacts-secondary-phone' placeholder=' '/>
              <TextInput {...props} formItemLayout={formItemLayout} label='Cell' name='pqf-contacts-secondary-cell' placeholder=' '/>
            </React.Fragment>}

            <Form.Item className='submit-controls' {...tailFormItemLayout}>
              <Button.Group compact>
                <Button onClick={handleSubmit} type='primary'>Save</Button>
                <Button onClick={handleReset}>Clear</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </Button.Group>
            </Form.Item>
          </Form>
        );
      }}
    </Formik>
  );
};

CompanyForm.propTypes = {
  company: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  duringRegistration: PropTypes.bool,
};

export default CompanyForm;



// WEBPACK FOOTER //
// ./src/components/Companies/CompanyForm.js